import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

@Component({
  standalone: false,
  selector: 'app-create-comment-modal',
  templateUrl: './create-comment-modal.component.html',
  styleUrls: ['./create-comment-modal.component.scss']
})
export class CreateCommentModalComponent {
  public comment: any;
  @ViewChild('createCommentModal') modal: ElementRef;
  @Output() closed = new EventEmitter();
  @Input() open: boolean;

  commentForm: FormGroup = this.formBuilder.group({
    commentName: ['']
  });

  @Input() confirmAction = (_comment: any) => {
    // noop - default implementation, overridden by parent
  };

  constructor(
    private formBuilder: FormBuilder
  ) { }

  closeModal() {
    this.open = false;
    this.commentForm.reset();
    this.closed.emit(false);
  }

  confirmModal() {
    this.comment = this.commentForm.get('commentName').value;
    this.confirmAction(this.comment);
    this.closeModal();
  }

  cancelModal() {
    this.closeModal();
  }
}
